export default function syncPan(viewerA:any, viewerB:any){
    viewerA.addHandler('pan', function(event:any) {
        // Get the center point from viewerA
        var center = viewerA.viewport.getCenter();
        var centerB = viewerB.viewport.getCenter();

        if(center.x !== centerB.x && center.y!== centerB.y){
            console.log("Sync pan...")
            // Set the same center point on viewerB
            viewerB.viewport.panTo(center, true);
        }
    });
}